/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import PlaceholderCard from "examples/Cards/PlaceholderCard";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

// Data
import profilesListData from "layouts/profile/data/profilesListData";

// Images
import homeDecor1 from "assets/images/home-decor-1.jpg";
import homeDecor2 from "assets/images/home-decor-2.jpg";
import homeDecor3 from "assets/images/home-decor-3.jpg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { authorizationRedirect } from "constants/api";
import { serverCodes } from "constants/api";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";



function Overview() {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    getCreditProfile();
  }, []);

  let getCreditProfile = () => {
    setLoading(true)
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://api.losync.com/api/v1/application/credit/get',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${Cookies?.get('accessT') || ''}`
      }
    };

    axios.request(config)
      .then((response) => {
        // console.log(response.data);
        setUserData(response?.data);
        setLoading(false)
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          authorizationRedirect();
        } else if (serverCodes.includes(error?.response?.status)) {
          toast.error('An error occurred, please try again later');
        }
        setLoading(false)
      });
  };
  // console.log(userData)
  return (
    <DashboardLayout>
      {loading ?
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        :
        <>

          <Header />
          <SoftBox mt={5} mb={3}>
            <Grid container spacing={3}>
              {/* <Grid item xs={12} md={6} xl={4}>
            <PlatformSettings />
          </Grid> */}
              <Grid item xs={12} md={6} xl={4}>
                <ProfileInfoCard
                  title="personal information"
                  // description="Hi, I’m Alec Thompson, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
                  description=""
                  info={{
                    fullName: `${userData?.data?.first_name || "- - -"} ${userData?.data?.middle_name || "- - -"} ${userData?.data?.last_name || "- - -"}`,
                    mobile: userData?.data?.phone || "- - -",
                    email: userData?.data?.email || "- - -",
                    dateOfBirth: userData?.data?.dob || "- - -",
                    gender: userData?.data?.gender || "- - -",
                    stateOfOrigin: userData?.data?.state_of_origin,
                    lgaOfOrigin: userData?.data?.lga_of_origin
                  }}
                  social={[]}
                  action={{ route: "", tooltip: "Edit Profile" }}
                />
              </Grid>
              <Grid item xs={12} md={6} xl={4}>
                <ProfileInfoCard
                  title="primary employment information"
                  description=""
                  info={{
                    employmentType: `${userData?.data?.primary_employment || "- - -"}`,
                    // stateCivilServiceLevel: userData?.data?.state_civil_service_level || "Not Applicable",
                    // stateCivilServiceNumber: userData?.data?.state_civil_service_number || "Not Applicable",
                    // federalCivilServiceLevel: userData?.data?.federal_civil_service_level || "Not Applicable",
                    // federalCivilServiceNumber: userData?.data?.federal_civil_service_number || "Not Applicable",
                    // federalMinistry: userData?.data?.federal_ministry_you_work || "Not Applicable",
                    // federalParastatal: userData?.data?.federal_parastatal_or_agency || "Not Applicable",
                    // schoolState: userData?.data?.student_state_of_school || "Not Applicable",
                    // schoolName: userData?.data?.student_school_name || "Not Applicable",
                    // enterprenuerIndustry: userData?.data?.enterprenuer_industry || "Not Applicable",
                    // enterprenuerSubindustry: userData?.data?.student_school_name || "Not Applicable",
                    // executiveIndustry: userData?.data?.executive_industry || "Not Applicable",
                    // executiveSubindustry: userData?.data?.executive_sub_industry || "Not Applicable",
                    // farmerIndustry: userData?.data?.farmer_industry || "Not Applicable",
                    // farmerSubindustry: userData?.data?.farmer_sub_industry || "Not Applicable",
                    employmentDuration: userData?.data?.years_of_employment || "- - -",
                    salaryRange: userData?.data?.primary_employment_salary || "- - -",
                  }}
                  social={[]}
                  action={{ route: "", tooltip: "Edit Profile" }}
                />
              </Grid>
                {/* secondary_employment: secEmploymentType === "Others" ? secOtherData : secEmploymentType,
                secondary_employment_title: "",
                secondary_state_civil_service_level: secEmploymentType === "State civil service" ? secGradeLevel : "",
                secondary_state_civil_service_number: secEmploymentType === "State civil service" ? secServiceNumber : "",
                secondary_federal_civil_service_number: secEmploymentType === "Federal civil service" ? secGradeLevel : "",
                secondary_federal_civil_service_number: secEmploymentType === "Federal civil service" ? secServiceNumber : "",
                secondary_federal_ministry_you_work: secMinistry,
                secondary_federal_parastatal_or_agency: secParastatal,
                secondary_student_state_of_school: secSchoolState,
                secondary_student_school_name: secSchoolName,
                secondary_enterprenuer_industry:  secEmploymentType === "Entrepreneur" ? secIndustry : "",
                secondary_enterprenuer_sub_industry:  secEmploymentType === "Entrepreneur" ? secSubIndustry : "",
                secondary_executive_industry: secEmploymentType === "Executive" ? secIndustry : "",
                secondary_executive_sub_industry: secEmploymentType === "Executive" ? subIndustry : "",
                secondary_farmer_industry: "Farmer",
                secondary_farmer_sub_industry: secEmploymentType === "Farmer" ? secSubIndustry : "",
                secondary_years_of_employment: secEmploymentYears,
                secondary_employment_salary: secSalaryRange, */}
              <Grid item xs={12} md={6} xl={4}>
                <ProfileInfoCard
                  title="Secondary employment information"
                  description=""
                  info={{
                    employmentType: `${userData?.data?.secondary_employment || "- - -"}`,
                    employmentDuration: userData?.data?.secEmploymentYears || "- - -",
                    salaryRange: userData?.data?.secondary_employment_salary || "- - -",
                  }}
                  social={[]}
                  action={{ route: "", tooltip: "Edit Profile" }}
                />
              </Grid>
              <Grid item xs={12} md={6} xl={12}>
                <ProfileInfoCard
                  title="Credit information"
                  description=""
                  info={{
                    mostImportantNeed: `${userData?.data?.need_for_credit || "- - -"}`,
                    secondMostImportantNeed: userData?.data?.need_for_credit_2 || "- - -",
                    sixMonthsPayback: userData?.data?.borrow_and_payback || "- - -",
                    highestEverBorrowed: userData?.data?.highest_ever_borrowed || "- - -",
                  }}
                  social={[]}
                  action={{ route: "", tooltip: "Edit Profile" }}
                />
              </Grid>
              {/* <Grid item xs={12} xl={4}>
            <ProfilesList title="conversations" profiles={profilesListData} />
          </Grid> */}
            </Grid>
          </SoftBox>
          {/* <SoftBox mb={3}>
            <Card>
              <SoftBox pt={2} px={2}>
                <SoftBox mb={0.5}>
                  <SoftTypography variant="h6" fontWeight="medium">
                    Projects
                  </SoftTypography>
                </SoftBox>
                <SoftBox mb={1}>
                  <SoftTypography variant="button" fontWeight="regular" color="text">
                    Architects design houses
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
              <SoftBox p={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} xl={3}>
                    <DefaultProjectCard
                      image={homeDecor1}
                      label="project #2"
                      title="modern"
                      description="As Uber works through a huge amount of internal management turmoil."
                      action={{
                        type: "internal",
                        route: "/pages/profile/profile-overview",
                        color: "info",
                        label: "view project",
                      }}
                      authors={[
                        { image: team1, name: "Elena Morison" },
                        { image: team2, name: "Ryan Milly" },
                        { image: team3, name: "Nick Daniel" },
                        { image: team4, name: "Peterson" },
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} xl={3}>
                    <DefaultProjectCard
                      image={homeDecor2}
                      label="project #1"
                      title="scandinavian"
                      description="Music is something that every person has his or her own specific opinion about."
                      action={{
                        type: "internal",
                        route: "/pages/profile/profile-overview",
                        color: "info",
                        label: "view project",
                      }}
                      authors={[
                        { image: team3, name: "Nick Daniel" },
                        { image: team4, name: "Peterson" },
                        { image: team1, name: "Elena Morison" },
                        { image: team2, name: "Ryan Milly" },
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} xl={3}>
                    <DefaultProjectCard
                      image={homeDecor3}
                      label="project #3"
                      title="minimalist"
                      description="Different people have different taste, and various types of music."
                      action={{
                        type: "internal",
                        route: "/pages/profile/profile-overview",
                        color: "info",
                        label: "view project",
                      }}
                      authors={[
                        { image: team4, name: "Peterson" },
                        { image: team3, name: "Nick Daniel" },
                        { image: team2, name: "Ryan Milly" },
                        { image: team1, name: "Elena Morison" },
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} xl={3}>
                    <PlaceholderCard title={{ variant: "h5", text: "New project" }} outlined />
                  </Grid>
                </Grid>
              </SoftBox>
            </Card>
          </SoftBox> */}
        </>

      }

      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Overview;
